import { CartService } from "../../services/cart.service";
import { Component, OnInit, AfterViewInit, OnDestroy, EventEmitter } from '@angular/core';
import { AppService } from "../../services/app.service";
import { ApiService } from "../../services/api.service";
import { GtagService } from "../../services/gtag.service";
import { FbService } from "../../services/fb.service";
 
declare var window:any;

@Component({
  selector: 'cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss'] 
})
export class CarrinhoPage implements OnInit,AfterViewInit,OnDestroy {
  
  public page:any      = {};
  public params:any    = {};
  public loader        = false
  public total         = 0
  public messageLoader = "Buscando seu carrinho. Aguarde !"
  public response:any = {
    data: "",
    status: 0
  }
  public servicos = [];
  public file                 = null;
  public usuario              = null;
  public hasItens             = false;
  public isSendAnalytics      = false;
  public itensBreadcrumbs     = [];
  public servicosRelacionados = [];
  public fileSession          = null;
  public changeTotal          = new EventEmitter();
  public faq                  = [];

  constructor(
    private CartService: CartService,
    private app: AppService,
    private api: ApiService,
    private gtag: GtagService,
    private fb: FbService
  ) { }
  

  updateCartEmit(id){

    this.deleteItem(id)

  }
  /**
   * 
   * Deleta um Item no Carrinho
   * 
   * 
   */
  deleteItem(id){

    for(var index = 0;index < this.servicos.length;index++) {

      if(id == this.servicos[index].id){
        this.servicos.splice(index,1)
      }
        
    }
    this.servicos = this.servicos;
    this.calcTotal();

  
  }
  /**
   * 
   * 
   * 
   * 
   */
  getData(){

    try{
      
      this.loader = true; 
      
      this.api.conteudo().page("carrinho").subscribe(response => {
      
        this.loader = false;
      
        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
                  
            this.page                  = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params                = JSON.parse(this.page.params);
            this.servicosRelacionados  = response.data.page.servicos;
            let cart                   = response.data.page.cart; 
            this.faq                   = response.data.page.faq; 

            if(cart == null){
              this.CartService.emitirUpdateTotalCart.emit({
                total: 0,
                qtd: 0
              });
            }else{
              this.servicos = cart.cart_itens;
              this.total    = cart.total;
              this.CartService.emitirUpdateTotalCart.emit({
                total: this.total,
                qtd: this.servicos.length
              });    
            }
            
            this.file = response.data.page.fileSession;

            this.app.setMetaDados(this.page.meta_title,this.page.meta_description);
            this.app.toTop(); 
              
          }

          this.response = { 
            data: "",
            status: 1
          }
            
        }else{

          this.response = {
            data: response.data,
            status: 500
          }

        }
      
      },(err) =>{
      
        this.loader = false;
        this.response = err;
      
      });
    
    }catch(e){
      
    }

  }
  /**
   * 
   * Busca os dados do Carrinho
   * 
   */
  getCart(){

    try{

      this.loader = true

      this.api.cart().get().subscribe(response =>{
        
        this.loader   = false

        if(response.status == 1){
          
          this.response = response

          if(this.response.data == null){
            this.CartService.emitirUpdateTotalCart.emit({
              total: 0,
              qtd: 0
            });
          }else{
            this.servicos = response.data.cart_itens;
            this.total    = response.data.total;
            this.CartService.emitirUpdateTotalCart.emit({
              total: this.total,
              qtd: this.servicos.length
            });    
          }
          
          this.file = response.fileSession;  

        }else{
          this.response = {
            data: response.data,
            status: 500
          }
        }
        
        this.app.toTop();

      },(err) =>{
        
        this.loader = false
        this.response = {
          data: err._body,
          status: 500
        }

      })

    }catch(e){

      this.loader = false
      this.response = {
        data: "Houve um erro Inesperado: "+e.message,
        status: 500
      }

    }

  }
  /**
   * 
   * Calcula o Total do Carrinho
   * 
   */
  calcTotal(){

    this.total = 0

    this.servicos.forEach(s => {

      this.total += ((s.qtd_adt*s.valor_adt)+(s.qtd_chd*s.valor_chd))+parseFloat(s.valor_servico)

    });
    this.changeTotal.emit(this.total); 
    this.CartService.emitirUpdateTotalCart.emit({
      total: this.total,
      qtd: this.servicos.length
    });

  }
  /**
   * 
   * Esvazia o Carrinho
   * 
   */
  esvaziar(){
    
    this.total         =  0;
    this.response.data = null; 

    this.CartService.emitirUpdateTotalCart.emit({
      total: 0,
      qtd: 0
    });
    this.app.toTop(); 
    
  }
  /**
   * 
   * Send analytics
   * 
   */
  sendAnalytics(){

    if(!this.isSendAnalytics){
      this.isSendAnalytics = true;
      setTimeout(() => {
      
        this.gtag.sendPage();
        this.fb.init();  
        this.fb.leadSingle();   

      },100);

    }

  } 
  /**
   * 
   * Set breadcrumbs
   * 
   */
  setBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Carrinho de Compras"
    });

  }
  /**
   * 
   * Faq show
   * 
   */
  faqShow(p){

    p.show = p.show ? false : true;

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit() {

    this.CartService.emitirDeleteItem.subscribe(id=>{
      this.updateCartEmit(id);
    });
    this.getData(); 
    this.setBreadcrumbs();

  }
  /**
   * 
   * After
   * 
   */
  ngAfterViewInit(): void {
    
  }
  /**
   * 
   * On Destroy
   * 
   */
  ngOnDestroy(): void{ 
    this.isSendAnalytics = false;
  }

}
